module.exports = __webpack_public_path__ + "img/vipFree.4c51b672.png";